<script>
  import { getToken } from "../js/local";
  import { UEX } from "../js/domains";

  import { navigate } from "svelte-routing";

  import { onMount } from "svelte";

  const token = getToken();

  onMount(() => {
    if (token !== "") {
      navigate("inicio", { replace: true });
    } else {
      navigate(UEX, { replace: true });
    }
  });
</script>
